// Configuration des textes multilingues pour les informations de l'hôtel

export const hotelTexts = {
  fr: {
    name: 'Hôtel Saint-Pierre',
    description: 'Dans le centre historique de Villedieu-les-poêles, premier centre français de fabrication de cuivre, l\'hôtel Saint-Pierre vous propose ses 20 chambres toutes équipées de salles de bains et de toilettes. Confortable et au calme, votre séjour sera des plus agréable.',
    shortDescription: 'Dans le centre historique de Villedieu-les-pôeles, premier centre français de fabrication de cuivre, l\'hôtel Saint-Pierre vous propose ses 20 chambres toutes équipées.',
    address: {
      street: '12 Place de la République',
      city: '50800 Villedieu-les-Pôeles',
      country: 'France',
    },
    contact: {
      phone: '+33 2.33.61.00.11',
      email: 'st.pierre.hotel@wanadoo.fr',
    },
    openingHours: 'Ouvert 7j/7 sauf dimanche soir\nFermeture entre 15h et 17h',
    about: 'À propos',
    quickLinks: 'Liens rapides',
    contactTitle: 'Contact',
    openingHoursTitle: 'Horaires d\'ouverture',
    features: [
      'Télévision avec câble',
      'WiFi gratuit',
      'Salles de bains privatives',
      'Restaurant traditionnel',
      'Brasserie',
      'Salle de banquet',
    ],
    history: 'Situé dans un bâtiment historique en plein centre de Villedieu-les-Poêles, l\'Hôtel Saint-Pierre combine le charme de l\'ancien avec le confort moderne.',
    region: {
      title: 'La région',
      description: 'La Normandie est une région magnifique. Découvrez-la à travers notre séléction de lieu à ne pas louper...',
      attractions: [
		{
			name: 'Fonderie des cloches',
			description: 'Découvrez la Fonderie Cornille Havard, héritière d’un savoir-faire ancestral à Villedieu-les-Poêles depuis le Moyen Âge. Dans son atelier historique, construit en 1865, artisans et compagnons perpétuent la fabrication de cloches monumentales pour les églises du monde entier, tout en ouvrant leurs portes à plus de 50 000 visiteurs chaque année. Un lieu unique où tradition et innovation se rencontrent, à ne pas manquer lors de votre séjour.',
			shortDescription: 'Fonderie historique à Villedieu-les-Poêles où sont fabriquées chaque année des cloches monumentales, alliant tradition et savoir-faire unique.',
			distance: '0.2 km',
			image: 'fonderie.jpg',
			url: 'https://cornille-havard.com/visiter-la-fonderie/',
		},
        {
          name: 'Atelier du Cuivre',
          description: 'Découvrez l’Atelier du Cuivre, une institution emblématique de Villedieu-les-Poêles où artisans passionnés perpétuent la tradition du travail du cuivre. Visitez les ateliers, admirez le savoir-faire unique et repartez avec un souvenir authentique de la région.',
          shortDescription: 'Artisanat traditionnel du cuivre à Villedieu-les-Poêles, un savoir-faire unique à découvrir.',
          distance: '0.5 km',
          image: 'atelier-cuivre.jpg',
          url: 'https://atelierducuivre-shop.com/fr/content/7-l-atelier-du-cuivre',
        },
        {
          name: 'Mont Saint-Michel',
          description: 'Classé au patrimoine mondial de l’UNESCO, le Mont-Saint-Michel est un site incontournable. Cette merveille médiévale, perchée sur un îlot rocheux, offre un panorama exceptionnel et une expérience hors du temps.',
		  shortDescription: 'Une merveille médiévale classée UNESCO, incontournable en Normandie.',
          distance: '45 km',
          image: 'mont-saint-michel.jpg',
          url: 'https://www.ot-montsaintmichel.com/',
        },
        {
          name: 'Plages du Débarquement',
          description: 'Les plages du Débarquement, témoins majeurs de l’Histoire, invitent à la mémoire et à la découverte. Parcourez ces lieux emblématiques du D-Day et rendez hommage à ceux qui ont marqué le cours du XXe siècle.',
		  shortDescription: 'Lieux historiques du D-Day, symboles de mémoire et de courage.',
          distance: '80 km',
          image: 'plages-debarquement.jpg',
          url: 'https://www.normandie-tourisme.fr/decouverte/d-day-et-bataille-de-normandie/les-plages-du-debarquement/',
        },
      ],
    },
  },
  en: {
    name: 'Hotel Saint-Pierre',
    description: 'In the historic center of Villedieu-les-poêles, the first French copper manufacturing center, Hotel Saint-Pierre offers 20 rooms all equipped with bathrooms and toilets. Comfortable and quiet, your stay will be most enjoyable.',
    shortDescription: 'In the historic center of Villedieu-les-pôeles, the first French copper manufacturing center, Hotel Saint-Pierre offers 20 fully equipped rooms.',
    address: {
      street: '12 Place de la République',
      city: '50800 Villedieu-les-Pôeles',
      country: 'France',
    },
    contact: {
      phone: '+33 2.33.61.00.11',
      email: 'st.pierre.hotel@wanadoo.fr',
    },
    openingHours: 'Open 7 days a week except Sunday evening\nClosed between 3pm and 5pm',
    about: 'About',
    quickLinks: 'Quick Links',
    contactTitle: 'Contact',
    openingHoursTitle: 'Opening Hours',
    features: [
      'Cable TV',
      'Internet access',
      'Private bathrooms',
      'Traditional restaurant',
      'Brasserie',
      'Banquet hall',
    ],
    history: 'Located in a historic building in the center of Villedieu-les-Poêles, Hotel Saint-Pierre combines old-world charm with modern comfort.',
    region: {
      title: 'The region',
      description: 'Normandy is a beautiful region. Discover it through our selection of places not to be missed...',
      attractions: [
		{
			name: 'Bell Foundry',
			description: 'Discover the Cornille Havard Bell Foundry, heir to an ancestral know-how in Villedieu-les-Poêles since the Middle Ages. In its historic workshop, built in 1865, artisans and craftsmen continue the tradition of casting monumental bells for churches around the world, while welcoming over 50,000 visitors each year. A unique place where tradition meets innovation-a must-see during your stay.',
			shortDescription: 'Historic foundry in Villedieu-les-Poêles where monumental bells are crafted each year, blending tradition and unique expertise.',
			distance: '0.2 km',
			image: 'fonderie.jpg',
			url: 'https://cornille-havard.com/visiter-la-fonderie/',
		},
        {
          name: 'Copper Workshop',
          description: 'Discover the Copper Workshop, an iconic institution in Villedieu-les-Poêles where passionate craftsmen continue the tradition of copperworking. Visit the workshops, admire their unique expertise, and take home an authentic souvenir from the region.',
		  shortDescription: 'Traditional copper craftsmanship in Villedieu-les-Poêles, a unique expertise to explore.',
          distance: '0.5 km',
          image: 'atelier-cuivre.jpg',
          url: 'https://atelierducuivre-shop.com/fr/content/7-l-atelier-du-cuivre',
        },
        {
          name: 'Mont Saint-Michel',
          description: 'A UNESCO World Heritage Site, Mont-Saint-Michel is an absolute must-see. This medieval marvel perched on a rocky island offers breathtaking views and a truly timeless experience.',
          distance: '45 km',
		  shortDescription: 'A UNESCO-listed medieval marvel, a must-see in Normandy.',
          image: 'mont-saint-michel.jpg',
          url: 'https://www.ot-montsaintmichel.com/',
        },
        {
          name: 'D-Day Landing Beaches',
          description: 'The D-Day Landing Beaches are powerful historical sites that invite remembrance and discovery. Explore these iconic locations and pay tribute to those who changed the course of the twentieth century.',
		  shortDescription: 'Historic D-Day sites, symbols of remembrance and bravery.',
          distance: '80 km',
          image: 'plages-debarquement.jpg',
          url: 'https://www.normandie-tourisme.fr/decouverte/d-day-et-bataille-de-normandie/les-plages-du-debarquement/',
        },
      ],
    },
  },
};

// Fonction utilitaire pour récupérer les textes de l'hôtel en fonction de la langue
export const getHotelText = (lang, path) => {
  const keys = path.split('.');
  let result = hotelTexts[lang];
  
  for (const key of keys) {
    if (result && result[key] !== undefined) {
      result = result[key];
    } else {
      return undefined;
    }
  }
  
  return result;
};

// Exportations pour maintenir la compatibilité avec les composants existants
export const hotelInfo = {
  name: hotelTexts.fr.name,
  description: hotelTexts.fr.description,
  shortDescription: hotelTexts.fr.shortDescription,
  address: hotelTexts.fr.address,
  contact: hotelTexts.fr.contact,
  openingHours: hotelTexts.fr.openingHours,
  features: hotelTexts.fr.features,
  history: hotelTexts.fr.history
};

export const regionInfo = {
  title: hotelTexts.fr.region.title,
  description: hotelTexts.fr.region.description,
  attractions: hotelTexts.fr.region.attractions
};
